import { GlobalStyles } from "@mui/material"

export const globalStyles = theme => (
  <GlobalStyles
    styles={{
      "*": {
        scrollbarWidth: "thin",
        scrollbarColor: `${theme.palette.primary.main} ${theme.palette.background.paper}`
      },
      "::-webkit-scrollbar": {
        width: "8px",
        height: "8px"
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "6px"
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: theme.palette.background.paper
      },
      body: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        margin: 0,
        fontFamily: "Inter, Roboto, sans-serif"
      }
    }}
  />
)
